import React from 'react';
import SponsorPart from './SponsorPart';
import './SponsorsPart.css';

const organizersImgs = [
    {
        src: 'imgs/logos/accenture.png',
        alt: 'Accenture',
        imgHeight: '60%',
        imgHeightMobile: '60%',
        styles: 'is-full',
        url: 'https://careers.accenture.com/sk-sk/Pages/index.aspx'
    },
    {
        src: 'imgs/logos/fiit.png',
        alt: 'STU FIIT',
        imgHeight: '80%',
        imgHeightMobile: '80%',
        styles: 'is-one-third-tablet is-full-mobile',
        url: 'https://www.fiit.stuba.sk/'
    },
    {
        src: 'imgs/logos/fei.png',
        alt: 'STU FEI',
        imgHeight: '80%',
        imgHeightMobile: '80%',
        styles: 'is-one-third-tablet is-full-mobile',
        url: 'https://www.fei.stuba.sk/'
    },
    {
        src: 'imgs/logos/fmfi.png',
        alt: 'FMFI',
        imgHeight: '80%',
        imgHeightMobile: '80%',
        styles: 'is-one-third-tablet is-full-mobile',
        url: 'https://www.fmph.uniba.sk/'
    }
];

const partnersImgs = [
    {
        src: 'imgs/logos/redhat.png',
        alt: 'RedHat',
        imgHeight: '45%',
        imgHeightMobile: '55%',
        styles: 'is-one-quarter-desktop is-one-third-tablet is-full-mobile',
        url: 'https://www.redhat.com/en/partners/accenture'
    },
    {
        src: 'imgs/logos/erste.png',
        alt: 'Erste',
        imgHeight: '65%',
        imgHeightMobile: '70%',
        styles: 'is-one-quarter-desktop is-one-third-tablet is-full-mobile',
        url: 'https://www.erstegroupit.com'
    },
    {
        src: 'imgs/logos/siemens.png',
        alt: 'Siemens',
        imgHeight: '30%',
        imgHeightMobile: '70%',
        styles: 'is-one-quarter-desktop is-one-third-tablet is-full-mobile',
        url: 'https://new.siemens.com/sk/sk/spolocnost/kariera.html'
    },
    {
        src: 'imgs/logos/mongodb.png',
        alt: 'MongoDB',
        imgHeight: '55%',
        imgHeightMobile: '60%',
        styles: 'is-one-quarter-desktop is-full-tablet is-full-mobile',
        url: 'https://www.mongodb.com/'
    }
];

const mediaPartnersImgs = [
    {
        src: 'imgs/logos/robimeit.png',
        alt: 'RobimeIt',
        imgHeight: '75%',
        imgHeightMobile: '75%',
        styles: 'is-full-tablet is-full-mobile',
        url: 'https://robime.it/'
    }
];

const supportersImgs = [
    {
        src: 'imgs/logos/seges.png',
        alt: 'Seges',
        imgHeight: '35%',
        imgHeightMobile: '23%',
        styles: 'is-one-third-tablet is-half-mobile',
        url: 'https://seges.sk/'
    },
    {
        src: 'imgs/logos/tuli.png',
        alt: 'Tuli',
        imgHeight: '30%',
        imgHeightMobile: '23%',
        styles: 'is-one-third-tablet is-half-mobile',
        url: 'https://tuli.sk/'
    },
    {
        src: 'imgs/logos/pivotal.png',
        alt: 'Pivotal',
        imgHeight: '50%',
        imgHeightMobile: '35%',
        styles: 'is-one-third-tablet is-half-mobile',
        url: 'https://pivotal.io/'
    },
    {
        src: 'imgs/logos/ableneo.png',
        alt: 'Ableneo',
        imgHeight: '40%',
        imgHeightMobile: '30%',
        styles: 'is-half-tablet is-half-mobile',
        url: 'https://www.ableneo.com/'
    },
    {
        src: 'imgs/logos/Whitestein.png',
        alt: 'Whitestein',
        imgHeight: '45%',
        imgHeightMobile: '40%',
        styles: 'is-half-tablet is-full-mobile',
        url: 'https://www.whitestein.com/'
    }
];

const Sponsors = () => (
    <section className="section" id="sponsors">
        <SponsorPart imgs={organizersImgs} title="ORGANIZERS" />
        <SponsorPart imgs={partnersImgs} title="PARTNERS" />
        <SponsorPart imgs={mediaPartnersImgs} title="MEDIA PARTNERS" />
        <SponsorPart imgs={supportersImgs} title="SUPPORTERS" />
    </section>
);

export default Sponsors;
